import { GameData } from "./gamestate/gameData";
import {
  stopAutoPlay,
  recoverGameBar,
  enablePlay,
  enableBet,
  enableCollect,
  enableCtBonusSpin,
  enableChangeBet,
  displayGambleBtn,
  gambleClick,
  checkUserBalToBet,
  enablePlayIfJackpotNotAvailable,
} from "../../common/functions/Functions_GameBar";
// import { getOptionPages } from "./optionPages";
import { closeOptionWindow } from "../../common/functions/Functions_OptionWindow";
import {
  updateUseInfoText,
  updateBalance,
  updateWinBar,
  // jackpotWinCheck,
  setAllowedInputs,
  displayeGambleGame,
  jackpotWinOnNonWinningGameSpin,
  isNullOrUndefined,
} from "../../common/functions/Functions_General";
import { GameBaseSetup } from "../../common/gameLib/BaseGame/GameBaseSetup";
// import { CommonData } from "../../common/datastructures/gamestate/gameData";

import {
  enableEmulationInterfaceOnFeatureSelect,
  updateEmulationStakeUse,
  updateEmulationWinBalance,
} from "../../common/gameLib/Replay/emulation/functionsEmulations";
import { isFullScreen } from "../../common/functions/helper.ts/FullScreenHelper";

export function updateWin(activeGameData: GameData) {
  let winamount = 0;
  enablePlay(false, activeGameData);
  //-new
  winamount = activeGameData.GameContext().gameRoundBalance.credits.amount;
  activeGameData.winValue.updateValue(winamount);

  if (activeGameData.GameContext().win.credits.amount == 0) {
    activeGameData.freeSpinMode.setMessageDisplay();
  }
  if (activeGameData.GameContext().finished) {
    activeGameData.newSergioWinANimation.displayWin(
      winamount,
      activeGameData.betSelected.value
    );
  } else {
    let winSpin = activeGameData.GameContext().win.credits.amount;
    if (activeGameData.GameContext().finished) {
      winSpin = activeGameData.GameContext().gameRoundBalance.credits.amount;
    }

    // let winRatio=winSpin/activeGameData.betSelected.value;

    //-display small win animations
    if (winamount > 0) {
      // && winRatio<bigWinRatio )
      activeGameData.newSergioWinANimation.displayWin(
        winSpin,
        activeGameData.betSelected.value
      );
    }
  }
  if (activeGameData.GameContext().bonusGameResult != undefined) {
    winamount = activeGameData.GameContext().win.credits.amount;
    activeGameData.winValue.updateValue(winamount);
  }
  updateWinBar(true, activeGameData);
  // console.log("update WIN");
  activeGameData.mainGame.setBonusLeft(
    activeGameData.GameContext().gameRoundBalance.bonusSpins
  );

  if (
    activeGameData.GameContext().bonusGameResult != undefined &&
    activeGameData.GameContext().bonus == false &&
    activeGameData.GameContext().gameRoundBalance.bonusSpins === 0 &&
    activeGameData.WildGame.isWildVisible() == false
  ) {
    // console.log("SANTA On LAST SPIN")
    displayBonusEndResultMessage(activeGameData);
  } else if (winamount == 0) {
    enablePlayIfJackpotNotAvailable(activeGameData);

    // setAllowedInputs(activeGameData)
  } else if (winamount > 0) {
    let totalBonuswin = activeGameData.GameContext().gameRoundBalance.credits
      .amount;
    if (
      activeGameData
        .GameContext()
        .allowedInputActions.indexOf(
          activeGameData.API_handler.getServerActionCollect()
        ) >= 0
    ) {
      activeGameData.newSergioWinANimation.displayWin(
        totalBonuswin,
        activeGameData.betSelected.value
      );
    }
  }
}

function displayBonusEndResultMessage(activeGameData: GameData) {
  activeGameData.disableAllBtns(activeGameData);

  let totalBonuswin = activeGameData.GameContext().gameRoundBalance.credits
    .amount;
  if (activeGameData.GameContext().finished) {
    activeGameData.newSergioWinANimation.displayWin(
      totalBonuswin,
      activeGameData.betSelected.value
    );
  }

  // console.log("showEndMsg", totalBonuswin);
  let bonusMessageBox = activeGameData.bonusGameInfos.getMessageBox();
  activeGameData.playable = false;
  setTimeout(() => {
    bonusMessageBox.displayMessageOut();
  }, 1000);

  // activeGameData.displayBonusTotalFn= (): void => { };
  // console.log('BONUS GAME END MESSAGE POP HERE')
}

// export function extraSpinDisplay(activeGameData: GameData) {
//   if (
//     activeGameData.GameContext().usedInputAction ==
//     activeGameData.API_handler.getServerActionBonusSpin()
//   ) {
//     // console.log(activeGameData.scatterList)

//     if (activeGameData.scatterList.length > 0) {
//       getPositionforExtraSpin(activeGameData);
//     }

//     // }
//     // }
//   }
// }
// function getPositionforExtraSpin(activeGameData: GameData) {
//   let extraWinLocationList = activeGameData.scatterList[0].scatterPositions;
//   // activeGameData.GameContext().winCombinations[0].scatterPositions;

//   // console.log(extraWinLocationList)
//   // let returnList=[];
//   let orbOrder = [0, 3, 6, 9, 12, 1, 4, 7, 10, 13, 2, 5, 8, 11, 14];
//   // let gotExtra = false;
//   for (var i = 0; i < extraWinLocationList.length; i++) {
//     for (let j = 0; j < 15; j++) {
//       if (extraWinLocationList[i] === j) {
//         // activeGameData.mainGame.orbLight.extraSpin[orbOrder[j]].addSpinTextTweenIn.start();
//         activeGameData.mainGame.setExtraSpinTextPlay(orbOrder[j]);

//         // gotExtra = true;
//         activeGameData.bonusGameInfos.animateExtraSpin();
//         activeGameData.mainGame.setBonusExtraSpinVisibleSelected(orbOrder[j]); //.dragonHighlighter.enableOrbSelected(orbOrder[j]);
//       }
//     }

//   }
// }

export function resetExtraSpin(activeGameData: GameData) {
  for (var i = 0; i < activeGameData.mainGame.getTotalColumns(); i++) {
    for (let j = 0; j < 5; j++) {
      // activeGameData.mainGame.columns[i].tileSprite[j].addSpinText.alpha = 0;
      // activeGameData.mainGame.columns[i].tileSprite[j].addSpinTextTweenIn.reset();
      // activeGameData.mainGame.columns[i].tileSprite[j].addSpinTextTweenIn.stop();
      // activeGameData.mainGame.columns[i].tileSprite[j].changeColor(false);
      activeGameData.mainGame.getColumn(i).setExtraSpinTweenCol(j); //.tileSprite[j].setExtraSpinTweenReset();
    }
  }

  // activeGameData.mainGame.setBonusExtraSpinVisible(false); //.dragonHighlighter.enableOrb(false);
}
// export function displayeGambleGame(bool: boolean, activeGameData: GameData) {
//   activeGameData.gambleGame.startGamble(bool);
// }
// function bonusGameInfo(activeGameData: GameData) {
//   // console.log("bonusSpinEnter")
//   if (activeGameData.bonusGameInfos.getIsVisibile() === false) {
//     displayBonusGameInfosWindow(true, activeGameData);
//     activeGameData.mainGame.setOutFrameBonusGameRandom(); //
//   }

//   bonusGameEffects(true, activeGameData);
//   activeGameData.bonusGameInfos.setSpinLeftText(activeGameData.GameContext().gameRoundBalance.bonusSpins.toString());

//   bonusGameTotalWinUpdate(activeGameData);
//   // console.log(((activeGameData.GameContext())).gameRoundBalance.bonusSpins)
// }
// function bonusGameTotalWinUpdate(activeGameData: GameData) {
//   activeGameData.bonusGameInfos.updateTotalWinDisplay();
// }
export function closeBonusGameMode(activeGameData: GameData) {
  if (activeGameData.bonusGameMode && activeGameData.bonusBG) {
    //&& activeGameData.bonusGameInfos.container.alpha===1)
    //close bonusgameMode items
    displayBonusGameInfosWindow(false, activeGameData);
    // activeGameData.bonusGameInfos.gameMessageDisplay.close();
    closeBonusWinMessageBox(activeGameData);
    bonusGameEffects(false, activeGameData);
  }
}
export function closeBonusWinMessageBox(activeGameData: GameData) {
  // activeGameData.bonusGameInfos.gameMessageDisplay.display(bool); //open the  message window
  let bonusMessageBox = activeGameData.bonusGameInfos.getMessageBox();
  bonusMessageBox.close();
  // activeGameData.bonusGameInfos.gameMessageDisplay.close();
}
// export function displayBonusIconDragonSymbol(
//   i: number,
//   activeGameData: GameData
// ) {
//   activeGameData.mainGame.setBonusSymbolLabelOnSelected(i); //.dragonHighlighter.enableIconSelected(i);
// }
// export function displayFireAroundDragonSymbol(
//   i: number,
//   activeGameData: GameData
// ) {
//   // activeGameData.mainGame.dragonHighlighter.enableSelected(i);
//   activeGameData.mainGame.setBonusSymbolFocusOnSelected(i); //dragonHighlighter.enableSelected(i);
// }
// export function hideDisplayFireAroundDragonSymbol(activeGameData: GameData) {
//   // activeGameData.mainGame.dragonHighlighter.enableFire(false);
//   activeGameData.mainGame.setBonusSymbolFocus(false);
// }
// export function disableDragonFX(activeGameData: GameData) {
//   // activeGameData.mainGame.dragonHighlighter.enableIcon(false);
//   // activeGameData.mainGame.dragonHighlighter.enableFire(false);
//   activeGameData.mainGame.setBonusSymbolFX(false);
// }
export function displayBonusGameInfosWindow(
  bool: boolean,
  activeGameData: GameData
) {
  if (bool) {
    // let tween = activeGameData.bonusGameInfos.getFadeIN();
    // tween.start();

    activeGameData.bonusGameInfos.setVisible(true);
    activeGameData.bonusGameInfos.setNewOrbMultiplierValue();
  } else {
    // activeGameData.bonusGameInfos.setTweenReset(); //container.alpha===1)
    activeGameData.bonusGameInfos.setVisible(false);
  }
  // activeGameData.bonusGameInfos.container.alpha=bool
}
// export function highlightOrbsonWinline(
//   winlineLengthValue: number,
//   activeGameData: GameData
// ) {
//   // console.log(winlineLengthValue)
//   if (activeGameData.bonusGameMode && activeGameData.bonusGameModeStarted) {
//     disablehighlightOrbsonWinline(activeGameData);

//     if (winlineLengthValue == 3) {
//       activeGameData.bonusGameInfos.setOrbAlpha(0, 1);
//     } //.smallOrbs[0].alpha = 1 }
//     if (winlineLengthValue == 4) {
//       activeGameData.bonusGameInfos.setOrbAlpha(1, 1);
//     } //smallOrbs[1].alpha = 1 }
//     if (winlineLengthValue == 5) {
//       activeGameData.bonusGameInfos.setOrbAlpha(2, 1);
//     } //smallOrbs[2].alpha = 1 }
//   }
// }
// export function disablehighlightOrbsonWinline(activeGameData: GameData) {
//   for (var i = 0; i < 3; i++) {
//     activeGameData.bonusGameInfos.setOrbAlpha(i, 0.5); //smallOrbs[i].alpha = 0.5
//   }
// }

export function disableAllBtns(activeGameData: GameData) {
  stopAutoPlay(activeGameData);
  // enableGamble(false, activeGameData);

  enableBet(false, activeGameData);
  enableCollect(false, activeGameData);
  enableCtBonusSpin(false, activeGameData);
  activeGameData.gameBar.setGambleBtnsButtonMode(false);
  activeGameData.gameBar.setButtonMode(false);
  activeGameData.jackPotGame.setCountersButtonVisible(false);
  // activeGameData.replay.disable(true);
}
export function resetAllBtns(activeGameData: GameData) {
  activeGameData.gameBar.setButtonMode(true);

  activeGameData.jackPotGame.setCountersButtonVisible(true);
  if (activeGameData.betResponse.gameContext != undefined) {
    setAllowedInputs(activeGameData);
  }

  // activeGameData.replay.disable(false);
}

export function checkSantaToExpand(activeGameData: GameData) {
  //--if expand wild is present do an expand wil request
  activeGameData.santaExpandable = true;

  setNewServerAction(activeGameData); //--check and define new action
  if (
    activeGameData.expandRequested == false &&
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionExpandWild()
      ) >= 0
  ) {
    activeGameData.playable = false;

    activeGameData.expandRequested = true;
    expandSantaRequest(activeGameData);
  } else {
    activeGameData.santaExpandable = false;
    activeGameData.WildGame.reloadSanta();
    // console.log("RELOAD");

    // setNewServerAction(activeGameData); //--check and define new action
  }
}

export function expandSantaRequest(activeGameData: GameData) {
  activeGameData.serverAction = activeGameData.API_handler.getServerActionExpandWild();

  if (activeGameData.replayMode == false) {
    var expandData = {
      action: activeGameData.serverAction,
      value: activeGameData.betSelected.value,
      // a:12
    };
    console.log(
      "_________________________________________>REQUEST EXPAND"
      // activeGameData.serverAction,
      // expandData
    );
    activeGameData.API_handler.GetGamePlayResult(
      expandData,
      activeGameData.ExpandSantaSuccess,
      activeGameData.betFail
    );
  } else {
    activeGameData.replay.incrementIndex();
    activeGameData.replay.getRoundContextData(); //--apply incrementation index and copy new context to the gamecontext
    //  console.log("contextNUM",activeGameData.betResponse.gameContext.contextNumber);
    activeGameData.ExpandSantaSuccess(activeGameData.betResponse);
  }
}

export function setNewServerAction(activeGameData: GameData) {
  // console.log("define new Action," ,activeGameData.GameContext().allowedInputActions)
  if (
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionRespin()
      ) >= 0
  ) {
    activeGameData.serverAction = activeGameData.API_handler.getServerActionRespin();
  } else if (
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionBet()
      ) >= 0
  ) {
    activeGameData.serverAction = activeGameData.API_handler.getServerActionBet();
  } else if (
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionCollect()
      ) >= 0
  ) {
    activeGameData.serverAction = activeGameData.API_handler.getServerActionCollect();
  } else if (
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionExpandWild()
      ) >= 0
  ) {
    activeGameData.serverAction = activeGameData.API_handler.getServerActionExpandWild();
  }
}
export function expandSuccess(data: any, activeGameData: GameData) {
  // console.log(
  //   "CHECK BONUS",
  //   activeGameData.GameContext().bonus,
  //   activeGameData.bonusGameModeStarted,
  //   activeGameData.gameMode
  // );

  activeGameData.betResponse = data;
  setNewServerAction(activeGameData);

  activeGameData.WildGame.expandAndUpdateSantaOnReel(); //---animate santa
  activeGameData.playable = true;
  // //--check for bonus
  // console.log("CHECK BONUS", activeGameData.GameContext().bonus,activeGameData.bonusGameModeStarted,activeGameData.gameMode)
  // if(activeGameData.GameContext().bonus && activeGameData.bonusGameModeStarted==false)
  // {
  //   // activeGameData.
  // }
}

export function toggleBonusGameMode(activeGameData: GameData) {
  if (
    activeGameData.GameContext().bonus ||
    activeGameData.GameContext().gameRoundBalance.bonusSpins > 0
  ) {
    activeGameData.gameMode = "bonusGame";
    activeGameData.bonusGameMode = true;

    // console.log(
    //   "ENABLE BONUS GAME",
    //   activeGameData.gameMode,
    //   activeGameData.bonusGameMode
    // );
  } else {
    activeGameData.gameMode = "normalGame";
    activeGameData.bonusGameMode = false;
    bonusGameEffects(false, activeGameData);
    disableFireWorks(activeGameData);
    addWinToUserInfo(
      activeGameData.GameContext().win.credits.amount,
      activeGameData
    );
    //

    // if (activeGameData.bonusGameInfos.getIsVisibile) {
    //   displayBonusGameInfosWindow(false, activeGameData);
    //   musicSelect(0, activeGameData);

    // }

    // console.log(3)
  }
}

export function replaceAllWithBonus(activeGameData: GameData, bool: boolean) {
  activeGameData.WildGame.clearAll();
  if (bool) {
    //bonus game start change all symbols to zero
    if (
      activeGameData.bonusGameModeStarted == false &&
      activeGameData.GameContext().bonus
    ) {
      // console.log("HEARE")
      activeGameData.mainGame.setbonusGameOverlayVisible(true);
      let lastIndex = activeGameData.allDice.length - 1;
      let empty = [lastIndex, lastIndex, lastIndex];

      activeGameData.mainGame.setFixedDices(empty, empty, empty, empty, empty);

      activeGameData.mainGame.setWinlineHidden();
    }
    // console.log("HEAREF")
  } else {
    //set back normal dice after bonus game ended

    let gameContext = activeGameData.GameContext();

    let r1 = [
      gameContext.baseGameResult.reels[0][0] - 1,
      gameContext.baseGameResult.reels[0][1] - 1,
      gameContext.baseGameResult.reels[0][2] - 1,
    ];
    let r2 = [
      gameContext.baseGameResult.reels[1][0] - 1,
      gameContext.baseGameResult.reels[1][1] - 1,
      gameContext.baseGameResult.reels[1][2] - 1,
    ];
    let r3 = [
      gameContext.baseGameResult.reels[2][0] - 1,
      gameContext.baseGameResult.reels[2][1] - 1,
      gameContext.baseGameResult.reels[2][2] - 1,
    ];
    let r4 = [
      gameContext.baseGameResult.reels[3][0] - 1,
      gameContext.baseGameResult.reels[3][1] - 1,
      gameContext.baseGameResult.reels[3][2] - 1,
    ];
    let r5 = [
      gameContext.baseGameResult.reels[4][0] - 1,
      gameContext.baseGameResult.reels[4][1] - 1,
      gameContext.baseGameResult.reels[4][2] - 1,
    ];
    activeGameData.mainGame.setFixedDices(r1, r2, r3, r4, r5);
    //change back to normal dice
    // console.log("switch")
    activeGameData.mainGame.changeBonusSymbolTint(true);
    checkSantaToExpand(activeGameData);
  }
  // checkSantaToExpand(activeGameData);
}

export function disableFireWorks(activeGameData: GameData) {
  activeGameData.environment.setFireWorks(false);
}
function bonusGameEffects(bool: boolean, activeGameData: GameData) {
  // console.log(activeGameData.environment.glowL.scale.x)
  if (bool) {
    if (activeGameData.environment.getGlowScale() === 8) {
      activeGameData.bonusBG = true;
      activeGameData.environment.setGlowScale(14);
      activeGameData.background.setNewTexture("game_BGB.png");

      //--portraitmode bg change
      activeGameData.portraitBGSky.texture = PIXI.Texture.fromFrame(
        "game_BGB.png"
      );
    }

    // playEyeAnimation(activeGameData, true);

    // console.log("playFireAnimationEye")
  } else if (activeGameData.environment.getGlowScale() === 14) {
    activeGameData.bonusBG = false;
    activeGameData.environment.setGlowScale(8);
    activeGameData.background.setNewTexture("game_BGDark.png");

    // playEyeAnimation(activeGameData, false);
    //--portraitmode bg change
    activeGameData.portraitBGSky.texture = PIXI.Texture.fromFrame(
      "game_BGDark.png"
    );
  }
}
function addWinToUserInfo(winnings: number, activeGameData: GameData) {
  if (winnings > 0) {
    activeGameData.msgtotalWIN += winnings;
  }

  activeGameData.msgtotalLOSE =
    activeGameData.msgtotalBET - activeGameData.msgtotalWIN; //+=activeGameData.betSelected.value;

  // console.log("BET:"+activeGameData.msgtotalBET+"  WIN"+activeGameData.msgtotalWIN+"  LOSE"+activeGameData.msgtotalLOSE);

  updateUseInfoText(activeGameData);
}
export function autoUpdateSettingsPage(activeGameData: GameData) {
  if (
    isFullScreen() &&
    activeGameData.gameOption.getFullScreenIsOn() === false
  ) {
    activeGameData.gameOption.setFullScreenOn(true);
  }
  if (
    activeGameData.normalGameMusic.volume() > 0 &&
    activeGameData.gameOption.getBgMusicIsOn() === false
  ) {
    activeGameData.gameOption.setBgMusicOn(true);
  }
  if (
    activeGameData.bonusGameMusic.volume() > 0 &&
    activeGameData.gameOption.getBonusMusicIsOn() === false
  ) {
    activeGameData.gameOption.setBonusMusicOn(true);
  }
  if (
    activeGameData.sound.volume() > 0 &&
    activeGameData.gameOption.getSoundIsOn() === false
  ) {
    activeGameData.gameOption.setSoundOn(true);
  }
  if (
    !isFullScreen() &&
    activeGameData.gameOption.getFullScreenIsOn() === true
  ) {
    activeGameData.gameOption.setFullScreenOn(false);
  }
  if (
    activeGameData.normalGameMusic.volume() === 0 &&
    activeGameData.gameOption.getBgMusicIsOn() === true
  ) {
    activeGameData.gameOption.setBgMusicOn(false);
  }
  if (
    activeGameData.bonusGameMusic.volume() === 0 &&
    activeGameData.gameOption.getBonusMusicIsOn() === true
  ) {
    activeGameData.gameOption.setBonusMusicOn(false);
  }
  if (
    activeGameData.sound.volume() === 0 &&
    activeGameData.gameOption.getSoundIsOn() === true
  ) {
    activeGameData.gameOption.setSoundOn(false);
  }
  // console.log("autoooo");
}
function playWinAnimationsCheck(activeGameData: GameData) {
  let allowPlayClick = false;
  if (activeGameData.replayMode == true) {
    allowPlayClick = true;
  } else if (
    activeGameData.newSergioWinANimation.isActive() === false &&
    activeGameData.WildGame.getIsergioExpanding() == false
  ) {
    //-make sure that sergio winanimation is complete
    // console.log('NO WIN ANIMATIOn ACTIVE')
    allowPlayClick = true;
  }

  // console.log("check",allowPlayClick)
  return allowPlayClick;
}
export function onPlayButtonDown(activeGameData: GameData) {
  activeGameData.minimumStakePopup.onFirstSpin();
  if (playWinAnimationsCheck(activeGameData)) {
    let playBtnMode = activeGameData.gameBar.getplayBtnIndex();

    // activeGameData.mainGame.setOrbLightsDefault(); //orbLight.stop();
    if (playBtnMode === 2 && activeGameData.playable) {
      // console.log("COLLECT")

      // if (activeGameData.autoPlayTicker.started === false) {}
      activeGameData.newSergioWinANimation.stop();
      // activeGameData.sergioWinAnimation.setVisible(false);

      activeGameData.gameBar.setGambleBtnsButtonMode(false);
      displayeGambleGame(false, activeGameData); //close gamble game Interface;
      if (activeGameData.bonusGameInfos.getIsVisibile() === true) {
        // if bonus Frame is open
        displayBonusGameInfosWindow(false, activeGameData);
        // displayBonusGameInfosWindowText(false,activeGameData);
      }

      activeGameData.gameBar.setPlayButtonIndex(3);
      activeGameData.gameBar.setBlackAndWhitePlay();
      activeGameData.mainGame.disableAllSymbolsAnimation();

      if (activeGameData.replayMode == false) {
        var collectData = { action: activeGameData.serverAction };
        // console.log(
        //   "==================================>COLLECT",
        //   activeGameData.serverAction
        // );
        activeGameData.API_handler.GetGamePlayResult(
          collectData,
          activeGameData.collectSuccess,
          activeGameData.collectFail
        );
      } else {
        // console.log(activeGameData.replayMode, "CCCCCCCCCCCOLLECT")
        activeGameData.collectSuccess(activeGameData.betResponse);
      }
    } else if (activeGameData.playable && playBtnMode === 0) {
      if (activeGameData.environment) {
        disableFireWorks(activeGameData);
      } // if fireworks is playing it stops once player hit play
      activeGameData.mainGame.setWinlineHidden();
      // console.log(activeGameData.balance.value >= activeGameData.betSelected.value,activeGameData.balance.value, activeGameData.betSelected.value)
      let respin = activeGameData.API_handler.getServerActionRespin();
      let isRespin = activeGameData.serverAction == respin;

      if (
        activeGameData.balance.value >= activeGameData.betSelected.value ||
        activeGameData.gameMode === "bonusGame" ||
        isRespin
      ) {
        if (activeGameData.gameMode === "bonusGame") {
          stopAutoPlay(activeGameData);
        }

        startPlaying(activeGameData);
      }
    } else if (
      activeGameData.preSkip == false &&
      activeGameData.mainGame.getIsGameStarted()
    ) {
      activeGameData.preSkip = true;
      activeGameData.gameBar.setBlackAndWhitePlay();
      // console.log('PRESKIP')
    }
  }
}

export function resetFx(activeGameData: GameData) {
  activeGameData.totalBonusSymbolVisible = 0;
  closeOptionWindow(activeGameData); //localfunction
  activeGameData.mainGame.changeBonusSymbolTint(false);
  activeGameData.mainGame.setbonusGameOverlayVisible(false);
  activeGameData.mainGame.clearExtraBonusSPinWindow();
  // disableDragonFX(activeGameData);
  // activeGameData.mainGame.setBonusExtraSpinVisible(false);
  // activeGameData.mainGame.setOrbLightsDefault(); //orbLight.stop();
  enablePlay(false, activeGameData);
  enableChangeBet(false, activeGameData); //disablebet;
  let bonusMessageBox = activeGameData.bonusGameInfos.getMessageBox();
  if (bonusMessageBox.getAlpha()) {
    bonusMessageBox.close();
  }
  //close popper
  activeGameData.autoplayPopper.close();
  activeGameData.betPopper.close();
  activeGameData.jackPotGame.closeDetailsPanel();

  if (activeGameData.isTournament) {
    activeGameData.tournamentmode.closeRankingsPopup();
  }
  if (
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionBet()
      ) >= 0 &&
    activeGameData.GameContext().bonusGameResult == undefined
  )
    activeGameData.mainGame.setBonusLeftVisible(false);
  activeGameData.API_handler;

  activeGameData.environment.checkMusicAndBonusMode();
}

function startPlaying(activeGameData: GameData) {
  if (
    activeGameData.serverAction ===
    activeGameData.API_handler.getServerActionExpandWild()
  ) {
    //if request is expand wild  DO nothing
    // console.log("ignore request",activeGameData.serverAction );
    if (activeGameData.replayMode) {
      // console.log(relpl)
      expandSantaRequest(activeGameData);
    }
  } else {
    if (activeGameData.gambleGame.getGambleVisibility()) {
      activeGameData.gambleGame.startGamble(false);
    }
    // activeGameData.mainGame.setbonusGameOverlayVisible(false);

    activeGameData.mainGame.setFocused(false);
    resetFx(activeGameData);

    let gameStarted = activeGameData.mainGame.getIsGameStarted();

    if (gameStarted === false) {
      //--
      activeGameData.preSkip = false;
      // activeGameData.gameBar.setBlackAndWhitePlay(); //change the color of play btn to black and white
      activeGameData.gameBar.setPlayButtonIndex(1); //skippable
      activeGameData.gameBar.setBlackAndWhitePlay(); //change the color of play btn to black and white
      //----------------
      // if (activeGameData.autoPlayTicker.started === false) {}
      activeGameData.newSergioWinANimation.stop();
      // activeGameData.sergioWinAnimation.setVisible(false);

      activeGameData.gameSkippable = false;
      activeGameData.activePlaying = true; //game is playing
      activeGameData.skipAnimation = false; //skipBool
      //activeGameData.mainGame.skipAnimation=activeGameData.skipAnimation;

      //infinitewin
      activeGameData.infiniteSpin = true; //set infinitespin bool to tru

      if (activeGameData.gameMode === "bonusGame") {
        activeGameData.bonusGameMode = true;
        activeGameData.bonusGameModeStarted = true;
        // disablehighlightOrbsonWinline(activeGameData);
      } else if (activeGameData.gameMode === "normalGame") {
        activeGameData.bonusGameMode = false;
        activeGameData.bonusGameModeStarted = false;
      }

      // console.log(
      //   "==========play btn press ======>",
      //   activeGameData.serverAction
      // );

      if (activeGameData.replayMode == false) {
        var betData = {
          action: activeGameData.serverAction,
          value: activeGameData.betSelected.value,
          // a:12
        };

        activeGameData.spinTimeCounter = Date.now();
        activeGameData.API_handler.GetGamePlayResult(
          betData,
          activeGameData.betSuccess,
          activeGameData.betFail
        );
        enableEmulationInterfaceOnFeatureSelect(activeGameData, false);
      } else {
        activeGameData.betSuccess(activeGameData.betResponse);
      }

      if (!checkIFExpandedSpinActive(activeGameData)) {
        activeGameData.winValue.updateValue(0);
        updateWinBar(true, activeGameData);
      }

      activeGameData.mainGame.startTicker(); //start infinite spin until result from server is received

      if (activeGameData.autoCountListselected > 0) {
        if (activeGameData.newSergioWinANimation.isActive() === false) {
          autoplayStart(activeGameData);
        }
      }
    } else if (
      activeGameData.betResponse.hasOwnProperty("jackpotContext") === false
    ) {
      activeGameData.skipGame(activeGameData);
      activeGameData.gameBar.setBlackAndWhitePlay();
    }

    if (
      activeGameData.autoCountListselected == 0 &&
      activeGameData.autoPlayTicker.started
    ) {
      //if player has used all the balance or if player  has reached the 0 stop ticker
      // enablePlay(false, activeGameData);
      stopAutoPlay(activeGameData);
    }
  }
}

function checkIFExpandedSpinActive(activeGameData: GameData) {
  let isInExpandRounds = false;
  if (
    activeGameData.GameContext().usedInputAction ==
      activeGameData.API_handler.getServerActionRespin() ||
    activeGameData.GameContext().usedInputAction ==
      activeGameData.API_handler.getServerActionExpandWild()
  ) {
    //on base game
    if (
      activeGameData.GameContext().bonus == false &&
      activeGameData.GameContext().bonusGameResult == undefined
    ) {
      isInExpandRounds = true;
    }
    //on bonus game
    else if (activeGameData.GameContext().bonusGameResult != undefined) {
      let expandedReels = activeGameData.GameContext().bonusGameResult
        .expandedWildReels;
      if (expandedReels.indexOf(true) >= 0) {
        isInExpandRounds = true;
      }
    }
  }

  return isInExpandRounds;
}
function autoplayStart(activeGameData: GameData) {
  activeGameData.autoCountListselected--;
  activeGameData.gameBar.setAutoPlayCount(activeGameData.autoCountListselected);
  if (activeGameData.autoPlayTicker.started === false) {
    activeGameData.autoPlayTicker.start();
  }
}

// export function skipGame(activeGameData: GameData) {
//   if (
//     activeGameData.skipAnimation === false &&
//     activeGameData.infiniteSpin === false
//   ) {
//     // && activeGameData.mainGame.skipEnabled)
//     enablePlay(false, activeGameData);
//     activeGameData.skipAnimation = true;
//     // stopAutoPlay(activeGameData);
//     // console.log('skip')
//   }
// }

export function clearOnReplayOpenClose(activeGameData: GameData) {
  // things that should be reset on bonus open and close
  activeGameData.totalBonusSymbolVisible = 0;
  activeGameData.mainGame.setbonusGameOverlayVisible(false); //--hide  overlay if  is visible
  activeGameData.bonusGameModeStarted = false;
  activeGameData.mainGame.setBonusLeftVisible(false);
  activeGameData.mainGame.clearExtraBonusSPinWindow();
  activeGameData.WildGame.clearAll();

  activeGameData.WildGame.clearHistory(); //--clear santa history
  // activeGameData.mainGame.setOrbLightsDefault();
  closeBonusWinMessageBox(activeGameData);
  activeGameData.mainGame.setWinlineHidden();
  if (activeGameData.jackPotGame.isJackpotOpen()) {
    activeGameData.jackPotGame.stop();
  }

  if (activeGameData.gambleGame.getGambleVisibility()) {
    activeGameData.gambleGame.startGamble(false);
  }
  activeGameData.newSergioWinANimation.stop();
  activeGameData.environment.checkBonusMusic();

  //---sergio Win Effects
  // activeGameData.sergioWinAnimation.setVisible(false);

  ///----RESET GAME SPECIFIC ELEEMNTS
  // activeGameData.GameContext().bonus=false;//set the GAMECONTEXT TO BONUS FALSE;
  activeGameData.serverAction = activeGameData.API_handler.getServerActionBet();
  activeGameData.GameContext().usedInputAction = activeGameData.serverAction;
  activeGameData.environment.isNight(false);
  activeGameData.mainGame.stopTicker(); //stop the ticker

  //-reset the gamebar
  activeGameData.gameBar.setGambleButtonActive(false);
}

export function replayFn(activeGameData: GameData) {
  // activeGameData.mainGame.setWinlineHidden();
  let usedInput = activeGameData.GameContext().usedInputAction;
  // console.log("set to", usedInput);
  if (activeGameData.bonusGameInfos.getMessageBox().getAlpha() == 1) {
    closeBonusWinMessageBox(activeGameData);

    activeGameData.replay.setClickable(true);

    if (activeGameData.replay.getIsNewRound()) {
      //if the previoys round or next round is clicked , it will close the message box but also spin new round
      startPlaying(activeGameData);
    }
  } else if (
    usedInput == activeGameData.API_handler.getServerActionBet() ||
    usedInput == activeGameData.API_handler.getServerActionBonusSpin() ||
    usedInput == activeGameData.API_handler.getServerActionRespin()
  ) {
    startPlaying(activeGameData);
  } else if (usedInput == activeGameData.API_handler.getServerActionCollect()) {
    onPlayButtonDown(activeGameData);
    activeGameData.replay.setClickable(true);
    // console.log("increment6")
    activeGameData.replay.incrementIndex();
  } else if (usedInput == activeGameData.API_handler.getServerActionGamble()) {
    // console.log("Start GAMBLE");
    if (activeGameData.gambleGame.getGambleVisibility() == false) {
      gambleClick(activeGameData); //open Gamble game

      setTimeout(function() {
        activeGameData.gambleGame.setReplayPick();
        // console.log("increment4")
        activeGameData.replay.incrementIndex();
        activeGameData.replay.setClickable(true);
      }, 500);
      // activeGameData.gambleGame.setReplayPick();
    } else {
      activeGameData.gambleGame.setReplayPick();
      // console.log("pick");
      // console.log("increment5")
      activeGameData.replay.incrementIndex();
      activeGameData.replay.setClickable(true);
    }
  } else {
    // console.log("Collect Game");
    activeGameData.replay.setClickable(true);
    activeGameData.gambleGame.startGamble(false);
    // activeGameData.replay.setClickable(true);
  }
}

export function betFailCallBack(
  activeGameData: GameData,
  gameBaseSetup: GameBaseSetup<GameData>
) {
  // gameBaseSetup.setErrorMessage(2);
  gameBaseSetup.setErrorMessage(6);
  disableAllBtns(activeGameData);
}

export function recoverFail(
  activeGameData: GameData,
  gameBaseSetup: GameBaseSetup<GameData>
) {
  // console.log('recoverFail')
  // gameBaseSetup.setErrorMessage(0);
  gameBaseSetup.setErrorMessage(6);
  disableAllBtns(activeGameData);
}

export function collectFailCallBack(
  activeGameData: GameData,
  gameBaseSetup: GameBaseSetup<GameData>
) {
  // gameBaseSetup.setErrorMessage(3);
  gameBaseSetup.setErrorMessage(6);
  disableAllBtns(activeGameData);
}
export function threeSecondCheckBetSuccess(
  data: any,
  activeGameData: GameData,
  gameBaseSetup: GameBaseSetup<GameData>
) {
  activeGameData;
  data;
  gameBaseSetup;
  let defaultSpinTime = 1700; //just an average  time of default game;
  let timeToWaitFromConfig =
    activeGameData.commonConfigData.minSpinDurationRequired - defaultSpinTime;
  let timeItTookAlready = Date.now() - activeGameData.spinTimeCounter;
  let timeToWait =
    timeItTookAlready >= timeToWaitFromConfig
      ? 0
      : timeToWaitFromConfig - timeItTookAlready;
  setTimeout(function() {
    betSuccessCallBack(data, activeGameData, gameBaseSetup);
  }, timeToWait);
}
export function betSuccessCallBack(
  data: any,
  activeGameData: GameData,
  gameBaseSetup: GameBaseSetup<GameData>
) {
  //-fakse
  // data={"gameContext":{"contextData":{"contextType":"DEFAULT","baseGameResult":{"reels":[[1,6,8],[9,9,9],[9,9,9],[1,9,6],[4,4,9]],"expandedWildReels":[false,true,true,false,false],"winCombinations":[]},"stake":{"amount":75,"currency":"EUR"},"win":{"credits":{"amount":0,"currency":"EUR"},"bonusSpins":0},"gameRoundBalance":{"credits":{"amount":52320,"currency":"EUR"},"bonusSpins":0},"gambleHistory":[],"bonus":false,"finished":false,"usedInputAction":"RESPIN","allowedInputActions":["EXPAND_WILDS"]}},"playerBalance":{"creditsBalance":{"amount":99925,"currency":"EUR"}}}

  activeGameData.betResponse = data;
  activeGameData.expandRequested = false;
  //--check santa to move
  if (
    activeGameData.serverAction ==
    activeGameData.API_handler.getServerActionRespin()
  ) {
    activeGameData.WildGame.moveToNewReel();
    // activeGameData.WildGame.
  } else {
    activeGameData.WildGame.clearAll();
  }

  //---

  enablePlay(false, activeGameData);

  if (activeGameData.freeSpinsCountReceived != activeGameData.freeSpinsCount) {
    //add the winnings for each spin of bonusgame on play button press because its autocollected by server and wont call otherwise
    activeGameData.freeSpinsWinning += activeGameData.winValue.getValue();

    activeGameData.gameBar.setFreeSpinWinValue(
      activeGameData.freeSpinsWinning.toFixed(2)
    );
  }

  activeGameData.mainGame.setGameStop(data.gameContext.contextData);

  activeGameData.infiniteSpin = false;
  // console.log(activeGameData.GameContext().winCombinations)
  let winComb = GetWinlineCombo(activeGameData);
  if (winComb != undefined) {
    activeGameData.winLength = winComb.length;
  } else {
    activeGameData.winLength = 0;
  }

  if (activeGameData.GameContext().bonus) {
    let bonusCountVisible = parseInt(
      activeGameData.bonusGameInfos.getSpinLeftText()
    );

    activeGameData.bonusGameInfos.setSpinLeftText(
      (bonusCountVisible - 1).toString()
    );
  }
  if (activeGameData.WildGame.isWildGameActive() == false) {
    activeGameData.mainGame.useBonus();
  }

  activeGameData.gameSkippable = true;

  if (
    activeGameData.gameMode === "normalGame" &&
    activeGameData.replayMode == false
  ) {
    activeGameData.msgtotalBET += activeGameData.betSelected.value; //keep adding up each BET

    ///-reset bet
    if (
      activeGameData.GameContext().finished &&
      activeGameData.serverAction ==
        activeGameData.API_handler.getServerActionBet()
    ) {
      updateBalance(activeGameData);
    }

    updateBalanceOnly(activeGameData);
  }

  activeGameData.freeSpinMode.useSpins(activeGameData);

  // if (activeGameData.betResponse.hasOwnProperty("jackpotContext")) {

  //     stopAutoPlay(activeGameData);

  //     startJackpot(activeGameData);

  //     activeGameData.gameBar.setPlayButtonIndex(0)//change icon once collected
  //     // activeGameData.gameBar.playBtnMode = 0;
  // }
  // else {

  // }

  if (activeGameData.betResponse === null) {
    gameBaseSetup.setErrorMessage(5);
  }

  let bool = activeGameData.betResponse.hasOwnProperty("jackpotContext");
  if (bool == false) {
    enablePlay(true, activeGameData);
  } else {
    // jackpotWinCheck(activeGameData);
    jackpotWinOnNonWinningGameSpin(activeGameData);

    //-play sergio
    activeGameData.WildGame.playJackpotVoice();
  }

  //check if skip was clicked
  if (activeGameData.preSkip) {
    activeGameData.preSkip = false;
    activeGameData.skipGame(activeGameData);
  } else {
    activeGameData.gameBar.setPlayButtonIndex(1); //skippable
  }

  //-----------Replay mode fix the stake use
  activeGameData.replay.replayStakeUseCheck(); //use stake
  // activeGameData.stakeChangeSuccess

  // if(Math.random()>.7)
  //   activeGameData.newSergioWinANimation.displayWin(11111,1);

  //--update gameround id display
  activeGameData.gameRoundDisplayOverlay.updateGameRound(
    data.gameRoundId,
    activeGameData
  );

  //-on emulation substract the player stake
  updateEmulationStakeUse(activeGameData);
}

export function updateBalanceOnly(activeGameData: GameData) {
  if (activeGameData.freeSpinsActive == false) {
    if (activeGameData.updateBalanceOnRecovery) {
      activeGameData.balance.updateValue(
        activeGameData.betResponse.playerBalance.creditsBalance.amount
      );
      activeGameData.gameBar.setBalValue(
        activeGameData.balance.getDisplayValue()
      );
    }
  }
}

export function collectSuccessCallBack(
  data: any,
  activeGameData: GameData,
  gameBaseSetup: GameBaseSetup<GameData>
) {
  enablePlay(false, activeGameData);

  if (activeGameData.freeSpinsCountReceived != activeGameData.freeSpinsCount) {
    activeGameData.freeSpinsWinning += activeGameData.winValue.getValue();
    activeGameData.gameBar.setFreeSpinWinValue(
      activeGameData.freeSpinsWinning.toFixed(2)
    );
  }
  activeGameData.betResponse = data;
  setAllowedInputs(activeGameData);
  updateBalance(activeGameData);
  activeGameData.gameBar.setPlayButtonIndex(0); //change icon once collected
  // activeGameData.gameBar.playBtnMode = 0;
  // activeGameData.mainGame.winlines.hide();
  activeGameData.mainGame.setWinlineHidden(); //winlines.hide();

  activeGameData.winValue.updateValue(0); //reset win bar collect
  displayGambleBtn(false, activeGameData);
  // checkUserBalToBet(activeGameData);
  checkUserBalToBet(activeGameData);

  if (activeGameData.betResponse === null) {
    gameBaseSetup.setErrorMessage(5);
  }
  activeGameData.freeSpinMode.setMessageDisplay();

  let bool = activeGameData.betResponse.hasOwnProperty("jackpotContext");
  if (bool == false) {
    enablePlay(true, activeGameData);
  } else {
    // jackpotWinCheck(activeGameData);
    jackpotWinOnNonWinningGameSpin(activeGameData);
    //-play sergio
    activeGameData.WildGame.playJackpotVoice();
  }

  if (activeGameData.replayMode) {
    activeGameData.replay.setClickable(true);
  }

  ///----------tournament points update-------
  activeGameData.tournamentUpdateScore();

  //--
  activeGameData.replay.replayCollectWinCheck();

  //update emulation balance if game round is ended
  updateEmulationWinBalance(activeGameData);
}

export function recoverSuccessCallBack(data: any, activeGameData: GameData) {
  // console.log("recoverGameBarCall")

  if (activeGameData.bonusGameInfos.getIsVisibile()) {
    displayBonusGameInfosWindow(false, activeGameData);
  }
  activeGameData.betResponse = data;

  if (activeGameData.GameContext().finished) {
    //clear the winlines and winning if game is finished on recovering
    activeGameData.GameContext().win.credits.amount = 0;
    activeGameData.GameContext().baseGameResult.winCombinations = [];

    if (
      activeGameData.GameContext().bonusGameResult != undefined &&
      activeGameData.GameContext().bonusGameResult.winCombinations != undefined
    ) {
      activeGameData.GameContext().bonusGameResult.winCombinations = [];
    }
  }

  activeGameData.playable = true;
  if (
    !isNullOrUndefined(activeGameData.GameContext().bonusGameResult) &&
    activeGameData.GameContext().bonus
  ) {
    activeGameData.bonusGameModeStarted = true;
    activeGameData.bonusGameMode = true;
  } else {
    activeGameData.bonusGameModeStarted = false;
  }
  // console.log("recoverGameBarCall",activeGameData)
  recoverGameBar(activeGameData);
  activeGameData.mainGame.setGameStop(data.gameContext.contextData);
  activeGameData.infiniteSpin = false;
  let winComb = GetWinlineCombo(activeGameData);
  if (winComb != undefined) {
    activeGameData.winLength = winComb.length;
  } else {
    activeGameData.winLength = 0;
  }

  activeGameData.mainGame.setMainGameContainerAlpha(1); //parentContainer.alpha = 1;
  setAllowedInputs(activeGameData);

  //--update gameround id display
  activeGameData.gameRoundDisplayOverlay.updateGameRound(
    data.gameRoundId,
    activeGameData
  );
}

export function onKeyDown(keyEvt: KeyboardEvent, activeGameData: GameData) {
  // console.log(key.keyCode)
  if (keyEvt.key === " " && activeGameData.gameBar.getPlayButtonMode()) {
    if (activeGameData.mainGame.getIsGameStarted() === false) {
      activeGameData.playFunction();
      activeGameData.gameSkipped = false; //enable skip
    } else if (
      activeGameData.skipAnimation === false &&
      activeGameData.gameSkipped === false &&
      activeGameData.gameSkippable
    ) {
      activeGameData.playFunction();
      activeGameData.gameSkipped = true; //disable skip
      activeGameData.gameSkippable = false;
    }
  }
}

export function GetWinlineCombo(activeGameData: GameData) {
  let winlineComb;
  if (
    activeGameData.bonusGameMode &&
    activeGameData.bonusGameModeStarted &&
    activeGameData.GameContext().bonusGameResult != undefined
  ) {
    if (
      activeGameData.GameContext().bonusGameResult.winCombinations != undefined
    ) {
      winlineComb = activeGameData.GameContext().bonusGameResult
        .winCombinations;
    }
  } else {
    if (
      activeGameData.GameContext().baseGameResult.winCombinations != undefined
    ) {
      winlineComb = activeGameData.GameContext().baseGameResult.winCombinations;
    }
  }
  return winlineComb;
}

export function getWinContext(activeGameData: GameData) {
  let winlineComb;

  if (
    activeGameData.GameContext().bonusGameResult != undefined &&
    activeGameData.bonusGameModeStarted
  ) {
    winlineComb = activeGameData.GameContext().bonusGameResult;
  } else {
    if (activeGameData.GameContext().baseGameResult != undefined) {
      winlineComb = activeGameData.GameContext().baseGameResult;
    }
  }
  return winlineComb;
}
